import {Formation} from '../formation';
import {Reponse} from './formation/reponse.model';
import {UserEnEchange} from '../user-en-echange';
import {Preavis} from './preavis/preavis.model';
import {Inscription} from "./enscol/inscription.model";
import {Commission} from "../commission";


export enum TypeNationaliteEnumeration {
    Unknown = 0,
    France = 1,
    EuropeNonFrance = 2,
    NonEurope = 3
}


export class CandidatureFormation {
    // noinspection JSUnusedGlobalSymbols
    constructor(
        public id?: number,
        public oldId?: number,
        public oldCfId?: number,
        public libelle?: string,
        public pageEdition?: string,
        public fc?: boolean,
        public ects?: number,
        public ordre?: number,
        public responseRang?: number,
        public avisRang?: number,
        public dateCreation?: any,
        public dateModification?: any,
        public dateSuppression?: any,
        public dateValidation?: any,
        public dateSortieLC?: any,
        public dateConfirmation?: any,
        public dateDesistement?: any,
        public userId?: number,
        public formationId?: number,
        public categorieFormationId?: number,
        public categorieFormation?: string,
        public commissionId?: number,
        public commission?: string,
        public responseId?: number,
        public response?: string,
        public conformeId?: number,
        public conforme?: string,
        public commentaireId?: number,
        public commentaire?: string,
        public commentaireLibre?: string,
        public persId?: number,
        public avisId?: number,
        public avis?: string,
        public statutId?: number,
        public statut?: string,
        public mentionId?: number,
        public parcoursId?: number,
        public disciplineId?: number,
        public discipline?: string,
        public niveauId?: number,
        public candidatureId?: number,
        public candidat?: string,
        public bourse?: boolean,
        public echelon?: string,
        public nom?: string,
        public prenom?: string,
        public civilite?: string,
        public dateNaissance?: any,
        public paysNationalite?: string,
        public typeNationalite?: string,
        public reinscription?: boolean,
        public email?: string,
        public telephoneFixe?: string,
        public dernierCursus?: string,
        public niveauAccessDiplomeLibelle?: string,
        public saved?: boolean,
        public ei?: number,
        public reponseMajorDiscipline?: string,
        public controleIdentiteAdmis?: boolean,
        public choixConfirmation?: number,
        public indicBourseExcellence?: boolean,
        public bourseExcellence?: boolean,
        // sont chargés dynamiquement si nécessaire
        public formation?: Formation,
        public commissionObject?: Commission,
        public reponses?: Reponse[],
        public listePreavis?: Preavis[],
        public ordreModifiable?: boolean,
        public userEnEchange?: UserEnEchange,
        public inscriptionsEnscol?: Inscription[],
        public inscriptionsEnscolString?: string,
        public statutEnscol?: string
    ) { }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/candidature-formation.model.ts